const inventoryState = {
    inventory: undefined,
    receivingInventory: false
};
export default inventoryState;
